import React from "react";
import { MainDiv } from "Pages/MyBatches/MyBatch/MyBatchMain";
import "./index.css";
// import { ChannelStatic } from "Pages/MyBatches/Channels/ChannelStatic";
import ChannelsPostHome from "Pages/MyBatches/Channels/ChannelsPostHome";

export const ChannelsHome = ({ batchDetailsData, selectedSubject }: any) => {
  return (
    <MainDiv screen={screen}>
      {/* <ChannelStatic></ChannelStatic> */}
      <ChannelsPostHome
        batchDetailsData={batchDetailsData}
        selectedSubject={selectedSubject}
      />
    </MainDiv>
  );
};
